// src/components/layout/Header.tsx
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Menu, X, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navLinks = [
    { name: "Domov", path: "/" },
    { name: "Pohištvo", path: "/pohistvo" },
    { name: "Umivalniki", path: "/umivalniki" },
    { name: "Drobno pohištvo", path: "/drobno-pohistvo" },
    { name: "Svetila", path: "/svetila" },
    { name: "Ogledala", path: "/ogledala" },
    { name: "Dodatki", path: "/dodatki" },
    { name: "Kontakt", path: "/kontakt" },
  ];

  const isLinkActive = (path: string) => {
    if (path === '/') {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header className="sticky top-0 z-50 bg-luxbeige/95 backdrop-blur-sm shadow-sm">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <Home className="w-6 h-6 text-luxgold" />
            <span className="text-luxdark font-semibold text-xl">Lux Decor</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`transition-colors ${
                  isLinkActive(link.path)
                    ? "text-luxgold font-medium border-b-2 border-luxgold" 
                    : "text-luxdark hover:text-luxgold"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Button asChild className="bg-luxgold hover:bg-luxgold/90 text-luxdark font-medium rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-luxgold/20">
              <Link to="/kontakt">
                Zahtevaj ponudbo
                <ArrowRight className="ml-2 w-4 h-4" />
              </Link>
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden p-2 rounded-md text-luxdark hover:bg-luxgold/10"
            aria-label="Toggle Menu"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div
        className={`md:hidden absolute top-full left-0 right-0 bg-luxlight shadow-md transition-transform duration-300 ease-in-out transform ${
          isMenuOpen ? "translate-y-0 opacity-100" : "-translate-y-2 opacity-0 pointer-events-none"
        }`}
      >
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`block py-2 transition-colors ${
                  isLinkActive(link.path)
                    ? "text-luxgold font-medium border-l-4 border-luxgold pl-2" 
                    : "text-luxdark hover:text-luxgold"
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <Button asChild className="bg-luxgold hover:bg-luxgold/90 text-luxdark font-medium rounded-lg w-full transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-luxgold/20">
              <Link to="/kontakt">
                Zahtevaj ponudbo
                <ArrowRight className="ml-2 w-4 h-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;